"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const AddRecording_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddRecording"));
const EditRecording_1 = __importDefault(require("@Components/WorkRegistrationSubs/EditRecording"));
const removers_1 = require("@App/helpers/work-entities/removers");
const entities_validators_1 = require("@App/helpers/work-entities/entities-validators");
const contexts_1 = require("@App/contexts");
const lodash_1 = require("lodash");
const TablesForm_1 = __importDefault(require("@Components/ViewWork/Table/TablesForm"));
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const table_cell_sanitizer_1 = require("@App/helpers/table-cell-sanitizer");
const format_release_date_1 = require("@App/helpers/format-release-date");
const RecordingsStep = () => {
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [typePopup, setTypePopup] = (0, react_1.useState)();
    const [editingRecording] = (0, react_1.useState)();
    const removeRecording = (removingRecording) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedRecordingsDraft = (0, removers_1.recordingRemover)(removingRecording, workDraftFromLocal);
        workStore.setWorkDraftToLocal(updatedRecordingsDraft);
    };
    const openSidebar = (type) => {
        setTypePopup(type);
        setSidebarIsOpen(true);
    };
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    const stepValidator = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const invalid = (0, entities_validators_1.recordingsInvalidCheck)(workDraftFromLocal.recordings);
        workStore.setWizardStepValidation(!invalid);
    };
    (0, react_1.useEffect)(() => {
        stepValidator();
    }, [workStore.workDraftLocal]);
    const workDraftFromLocal = workStore.workDraftLocal;
    const workById = workStore.workById;
    if (!workDraftFromLocal) {
        return null;
    }
    const recordings = workDraftFromLocal.recordings;
    const recordingsFromWork = workDraftFromLocal.id && workDraftFromLocal.isComplete && workById && workById.recordings;
    const currentRecordings = recordingsFromWork ? (0, lodash_1.difference)(recordings, recordingsFromWork) : [];
    const tableInfos = (0, react_1.useMemo)(() => {
        const recordingTableRows = () => {
            const recordingModels = recordingsFromWork ? currentRecordings : recordings;
            return recordingModels.map((recordingModel) => {
                var _a, _b;
                return ({
                    removeCellIdentifier: (_b = (_a = recordingModel.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    removable: true,
                    cells: [
                        recordingModel.artistName,
                        recordingModel.title,
                        (0, table_cell_sanitizer_1.tableCellSanitizer)(recordingModel.isrc),
                        (0, table_cell_sanitizer_1.tableCellSanitizer)((0, format_release_date_1.formatReleaseDate)(recordingModel.releaseDate)),
                        (0, table_cell_sanitizer_1.tableCellSanitizer)(recordingModel.label),
                        (0, table_cell_sanitizer_1.tableCellSanitizer)(recordingModel.duration, '--:--'),
                    ],
                });
            });
        };
        return [
            {
                headerRow: {
                    row: [
                        { text: 'Recording Artist' },
                        { text: 'Recording Title' },
                        { text: 'ISRC' },
                        { text: 'Release Date' },
                        { text: 'Label' },
                        { text: 'Duration' },
                    ],
                    removableCells: true,
                },
                rows: recordingTableRows(),
            },
        ];
    }, [recordingsFromWork, recordings, currentRecordings]);
    return (react_1.default.createElement("div", { className: 'recordings-step' },
        react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Add Recordings', title: workDraftFromLocal.title },
            react_1.default.createElement("span", null, "(Optional) Enter recording information for your work."),
            react_1.default.createElement("span", null,
                "Recording information is used during the automated matching process but does not guarantee matches. This information will not be visible once your work is accepted into your catalog, but the information is stored in the database. ",
                react_1.default.createElement("strong", null, "Please note:"),
                " Multiple recordings may be matched to one work.")),
        react_1.default.createElement(TablesForm_1.default, { className: 'registration-recordings-table', headingDecoration: {
                icon: 'recording',
                title: 'Recordings',
                required: false,
            }, tableInfos: tableInfos, addButtonTitle: 'Add Recording', onAddButtonClicked: () => {
                openSidebar('addRecording');
            }, onRemoveCellClicked: (index) => {
                removeRecording(recordings[index]);
            } }),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: closeSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
                typePopup === 'addRecording' ? react_1.default.createElement(AddRecording_1.default, { closePopupFunc: closeSidebar }) : null,
                typePopup === 'editRecording' && editingRecording ? (react_1.default.createElement(EditRecording_1.default, { editingRecording: editingRecording, closePopupFunc: closeSidebar })) : null))));
};
exports.default = (0, mobx_react_1.observer)(RecordingsStep);
